import React from "react";

import Info from "./Info";

import EditCard from "uicomponents/EditCard";

import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { AppDocumentType, BusinessAttributeType } from "types";

interface IBusinessAttributesReviewProps {
  data: BusinessAttributeType;
  setActiveStepIndex: (index: number) => void;
  sectionNumber: number;
  documents: AppDocumentType;
}

type TDataEntries = [keyof BusinessAttributeType, string];

const BusinessAttributesReview = ({
  data,
  setActiveStepIndex,
  sectionNumber,
  documents,
}: IBusinessAttributesReviewProps): JSX.Element => {
  if (!data) {
    return <></>;
  }

  const questions = Object.entries(
    sectionsQuestions.businessAttributes.questions
  ) as TDataEntries[];
  return (
    <EditCard
      title={`${sectionsQuestions.businessAttributes.title}`}
      onEditClick={() => setActiveStepIndex(sectionNumber)}
    >
      {questions.map(([key, value]) => {
        if (key === "volunteerAccidentPolicy") {
          return (
            <Info
              key={key}
              question={value}
              answer={
                documents?.find((item) => item.applicationField === key)
                  ?.fileName
              }
              questionFieldName={key}
            />
          );
        }
        if (key === "materialSafetyDataSheets") {
          return (
            <Info
              key={key}
              question={value}
              answer={
                documents?.find((item) => item.applicationField === key)
                  ?.fileName
              }
              questionFieldName={key}
            />
          );
        }

        return (
          <Info
            key={key}
            question={value}
            answer={data?.companyInformation?.bizActivities?.[key]}
            questionFieldName={key}
          />
        );
      })}
    </EditCard>
  );
};

export default BusinessAttributesReview;
